module.exports = __webpack_public_path__ + "static/about-us-our-core-values-hero-eab7ae2b1985b14e0a153c6b39bccc52.jpg";